import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import {Power3, TweenLite} from "gsap";
import ReactDOM from 'react-dom'

import {TransitionGroup} from 'react-transition-group'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toggleCollapsibleContent} from "../../actions/Util";
import {faMinus} from "@fortawesome/pro-light-svg-icons/faMinus";
import {faPlus} from "@fortawesome/pro-light-svg-icons/faPlus";

class CollapsibleInside extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {
            isAnimating: false
        }
    }

    componentWillAppear(callback) {
        callback()
    }

    componentWillEnter(callback) {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
        TweenLite.set(dom, {clearProps: "all"});
        TweenLite.from(dom, 0.25, {
            ease: Power3.ease, opacity: 0, height: 0, onComplete: () => {
                this.setState({
                    isAnimating: false
                })
                TweenLite.killTweensOf(dom)
                TweenLite.set(dom, {clearProps: "all"});
                callback()
            }
        })
        this.setState({
            isAnimating: true
        })
    }

    componentWillUnmount() {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
        TweenLite.set(dom, {clearProps: "all"});
    }

    componentWillLeave(callback) {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
        TweenLite.set(dom, {clearProps: "all"});
        TweenLite.to(dom, 0.25, {
            ease: Power3.ease, opacity: 0, height: 0, onComplete: () => {
                this.setState({
                    isAnimating: false
                })
                TweenLite.killTweensOf(dom)
                TweenLite.set(dom, {clearProps: "all"});
                callback()
            }
        })
        this.setState({
            isAnimating: true
        })
    }

    render() {
        return (
            <div className={"toggle-content__inside-wrapper " + (this.state.isAnimating ? 'animating' : '')}>
                <div className="toggle-content__inside">
                    {this.props.children}
                </div>
            </div>
        )
    }
}

function Collapsible(props) {


    return (
        <div className={"toggle-content" + (props.isToggled ? " toggle-content--toggled" : "")}>
            <button type="button" onClick={props.toggleContent} className="toggle-content__toggle">
                <FontAwesomeIcon icon={props.isToggled ? faMinus : faPlus}/>
                {props.label}
            </button>
            <TransitionGroup
                component="div"
            >
                {props.isToggled && <CollapsibleInside key={props.id}>{props.children}</CollapsibleInside>}
            </TransitionGroup>
        </div>
    );

}

Collapsible.propTypes = {
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};


const mapStateToProps = (state, ownProps) => {
    return {
        isToggled: state.collapsibles[ownProps.id]
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {

    return {
        toggleContent: () => {
            dispatch(toggleCollapsibleContent(ownProps.id))
        }
    }

}


export default connect(mapStateToProps, mapDispatchToProps)(Collapsible)



/** WEBPACK FOOTER **
 ** ./src/containers/util/Collapsible.js
 **/